import { useNode, Element } from "@craftjs/core";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { applyStyleProps, defaultStyleProps, type ResponsiveStyleProps } from "@/lib/craft/style-props";
import { ContainerBlockSettings } from "@/components/craft/settings/ContainerBlockSettings";
import { TextBlock } from "./TextBlock";

type ContainerBlockProps = {
  className?: string;
  style?: ResponsiveStyleProps;
  children?: ReactNode;
};

export function ContainerBlock({
  className = "",
  style = defaultStyleProps(),
  children,
}: ContainerBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    id,
  } = useNode((node) => ({ selected: node.events.selected, id: node.id }));

  const { style: inlineStyle, className: styleClass } = applyStyleProps(style, "desktop", id);

  return (
    <div
      ref={(ref) => {
        if (ref) connect(drag(ref));
      }}
      className={cn(
        "container-page py-8 md:py-12",
        className,
        styleClass,
        `craft-node-${id}`,
        selected && "outline outline-2 outline-dashed outline-primary/30",
      )}
      style={inlineStyle}
    >
      {children}
    </div>
  );
}

ContainerBlock.craft = {
  displayName: "Container",
  isCanvas: true,
  props: {
    className: "",
    style: defaultStyleProps(),
  },
  rules: {
    canDrag: () => true,
    canMoveIn: () => true,
  },
  related: {
    settings: ContainerBlockSettings,
  },
};

export function ContainerCanvas() {
  return (
    <Element is={ContainerBlock} canvas className="">
      <TextBlock text="Add blocks from the toolbox or drag to rearrange." variant="p" />
    </Element>
  );
}
